import { createFileRoute } from '@tanstack/react-router';

import { getSamplingQueries, PratiquesPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/pratiques')({
  loader: async ({ context }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.pratiques.list({
        page: 1,
        sorting: [],
        filters: [],
      }),
    );
  },
  component: PratiquesPage,
});
